export default __webpack_public_path__ + "static/lepers-food-e47d979ee4c1ccc036e7e131e1159d72.jpg";